import React from 'react'

import Layout from '../../Layout/Layout'
import Footer from '../../Layout/Footer'
import ProductsDetailsSection3 from './ProductsDetailsSection3'
import ProductsDetailsSection4 from './ProductsDetailsSection4'
import ProductsDetailsSection5 from './ProductsDetailsSection5'
import ProductsDetailsSection6 from './ProductsDetailsSection6'
import ProductsShopSection7 from './ProductsShopSection7'

import ProductsShopSection9 from './ProductsShopSection9'
import ProductShopSection3 from './ProductShopSection3'
import ProductShopSection4 from './ProductShopSection4'
import ProductShopSection5 from './ProductShopSection5'
import ProductShopSection11 from './ProductShopSection11'
import ProductShopSection12 from './ProductShopSection12'
import ProductShopSection13 from './ProductShopSection13'
import ProductShopSection6 from './ProductShopSection6'
import ProductShopSection14 from './ProductShopSection14'
import ProductShopSection20 from './ProductShopSection20'
import ProductShopSection17 from './ProductShopSection17'
import ProductShopSection18 from './ProductShopSection18'
import ProductShopSection19 from './ProductShopSection19'
import ProductShopSection8 from './ProductShopSection8'
import ProductShopSection21 from './ProductShopSection21'
import ProductShopSection22 from './ProductShopSection22'
import ProductShopSection23 from './ProductShopSection23'
import ProductShopSection25 from './ProductShopSection25'
import ProductShopSection24 from './ProductShopSection24'
import ProductShopSection26 from './ProductShopSection26'
import ProductShopSection27 from './ProductShopSection27'

import { useLocation } from "react-router-dom";
import { useEffect } from "react";
// import FooterCalendar from '../../Layout/FooterCalendar'
import FooterNew from '../../Layout/FooterNew'
// import Product28 from './Product28'


function ProductsPage() {

    const location = useLocation();

  // useEffect(() => {
  //   if (location.state.category === "cupping") {
  //     const section = document.getElementById("cupping-therapy-section");
  //     if (section) {
  //       section.scrollIntoView({ behavior: "smooth", block: "start" });
  //     }
  //   } else {
  //     // Scroll to top by default when opening products page
  //     window.scrollTo(0, 0);
  //   }
  // }, [location]);

useEffect(() => {
  if (location.state?.category) {
    const section = document.getElementById(location.state.category);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  } else {
    // Scroll to top by default
    window.scrollTo(0, 0);
  }
}, [location]);



  return (
    <>
    <Layout/>
    <div id='cupping'>
 <ProductShopSection27/>
    </div>
    <div id='hijama'>
    <ProductsDetailsSection3/>
    </div>
    <div id='Microneedling'>
  <ProductsDetailsSection4/>
    </div>
  <div id='HijamaBooks'>
<ProductsDetailsSection5/>
   
  </div>
    
   <div id='BodyMassage'>
<ProductShopSection3/>
   </div>
    <div id='Bed'>
      <ProductShopSection4/>
    </div>
    
    {/* <ProductShopSection5/> */}
    <div id="Vaccume">
 <ProductShopSection6/>
    </div>
   
     <div id='BeautyProducts'>
      <ProductsShopSection7/>
     </div>
    <div id='Trichology'>
      <ProductShopSection8/>
    </div>
    <div id='SurgicalItems'>
 <ProductsShopSection9/>
    </div>
   
 <div id='BeautyMachine'>
     <ProductShopSection11/>
 </div>
 <div id='cuppingset'>
<ProductShopSection12/>
 </div>
    <div id='SmartBody'>
 <ProductShopSection13/>
    </div>
   <div id='Bath'>
 <ProductShopSection14/>
   </div>
   <div id='InfraRed'>
   <ProductShopSection17/>
   </div>
 <div id='Fitness'>
 <ProductShopSection18/>
 </div>
   <div id='Pain'>
 <ProductShopSection19/>
   </div>
   <div id='FacialTool'>
 <ProductShopSection20/>
   </div>
   <div id='Accupuncture'>
<ProductShopSection21/>
   </div>
    <div id='Mole'>
  <ProductShopSection22/>
    </div>
  <div id='Lancet'>
   <ProductShopSection23/>
  </div>
 <div id='DispoGloves'>
<ProductShopSection24/>
 </div>
    <div id='Unani'>
<ProductShopSection25/>
    </div>
    <div id='FacialSerum'>
  <ProductShopSection26/>
    </div>
  
    <div id='MoreItems'>
<ProductsDetailsSection6/>
    </div>
     
  {/* <FooterCalendar/> */}
    <FooterNew/>
    
    </>
  )
}

export default ProductsPage
